import {
  GET_LIST_THUDELETE,
  GET_LIST_THUDELETE_SUCCESS,
  GET_LIST_THUDELETE_FAILURE,
  UPDATE_SEARCHTDATA_THUDELETE,
} from "./actionTypes";

export const getListThuDelete = (dataSearch) => ({
  type: GET_LIST_THUDELETE,
  dataSearch,
});
export const getListThuDeleteSuccess = (data) => ({
  type: GET_LIST_THUDELETE_SUCCESS,
  payload: data,
});
export const getListThuDeleteFailure = (dataSearch) => ({
  type: GET_LIST_THUDELETE_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_THUDELETE,
  payload: data,
});
